export const COLLECTION_ROW_ADD = 'form:collection:add';

export const TOMSELECT_OPEN   = 'tomselect:open';
export const TOMSELECT_CLOSE  = 'tomselect:close';
export const TOMSELECT_CHANGE = 'tomselect:change';


const EVENTS = {
    [COLLECTION_ROW_ADD]: (collectionId) => new CustomEvent(COLLECTION_ROW_ADD, {
        bubbles: true,
        detail: {
            collectionId,
        },
    }),
};

/**
 * @param {HTMLElement} target
 * @param {string} eventName
 * @param {...*} args
 * @return {CustomEvent}
 */
export function dispatch(target, eventName, ...args) {
    const event = EVENTS[eventName](...args);

    target.dispatchEvent(event);

    return event;
}
